/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Table_Overwrite_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to overwrite \"{name}\"?" |
*
* @param {Explorer_Table_Overwrite_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_text = /** @type {((inputs: Explorer_Table_Overwrite_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir ecraser "${i?.name}" ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich überschreiben?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler sovrascrivere "${i?.name}"?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите перезаписать "${i?.name}"?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Está seguro de que desea sobrescribir "${i?.name}"?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要覆盖“${i?.name}”吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」を上書きしてもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को ओवरराइट करना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja sobrescrever "${i?.name}"?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to overwrite "${i?.name}"?`)
});